export default {
  stat: 'statisticsWidget-item',
  value: 'statisticsWidget-item-value',
  shortValue: 'statisticsWidget-item-short-value',
  description: 'statisticsWidget-item-description',
  percentage: 'statisticsWidget-item-percentage',
  info: 'statisticsWidget-item-info',
  tooltip: 'statisticsWidget-item-tooltip',
  loader: 'statisticsWidget-item-loader',
};
